import * as Styled from './BlueskyPosts.styled'

import { BlueskyPostsProps } from './types'
import Analysis from '../../components/analysis'

import { Row, Column } from '@zera-admin/page'
import { useEffect, useState } from 'react'
import UpdateButton from '../../components/update-button/UpdateButton'
import { useFlagcardContext } from 'app/contexts/flagcard'
import { PostBlueSky } from '../../widgets/types'
import WidgetLayout from '../../widgets/widget-layout'
import { AnalysisData } from '../../components/analysis/types'
import { getAgendaReportBluesky } from 'services/http/report/agenda-report-4/endpoint'
import BlueSkyCard from '../../components/bluesky-card/BlueSkyCard'

const BlueskyPosts = ({
  date,
  isEditValue,
  setIsEditValue,
  pageNumber,
  title,
  data,
  metaData,
}: BlueskyPostsProps) => {
  const [postDatas, setPostDatas] = useState<PostBlueSky | undefined>(data)
  const [postId, setPostId] = useState<string | undefined>()

  const [pageData, setPageData] = useState<{
    title: string
    pageNumber: number
  }>({ title: title, pageNumber: pageNumber })

  const [editMode, setEditMode] = useState<boolean>(false)

  const [flagCard] = useFlagcardContext()

  useEffect(() => {
    if (isEditValue === pageNumber) {
      setEditMode(true)
    }
  }, [isEditValue, pageNumber])

  useEffect(() => {
    if (isEditValue === -1) {
      setPostDatas(data)
      setPageData({ title: title, pageNumber: pageNumber })
    }
  }, [isEditValue, data, title, pageNumber])

  const handleDeletePost = () => {
    setPostDatas(undefined)
  }

  const addPost = () => {
    getAgendaReportBluesky({
      GroupId: metaData?.GroupId,
      Rkey: postId,
    })
      .then((res) => {
        setPostDatas(res.data.data)
      })
      .catch((err) => {
        console.log(err)
        flagCard.add({
          appearance: 'error',
          title: 'Bir hata oluştu',
          children:
            'Veritabanında post bulunamadı. Lütfen post ID bilgisini kontrol ediniz.',
        })
      })
  }

  const onChange = (key: string, value: string) => {
    postDatas && setPostDatas({ ...postDatas, [key]: value })
  }

  const onChangePageData = (key: string, value: string) => {
    setPageData({
      ...pageData,
      [key]: value,
    })
  }

  const editProps = {
    isEditValue: isEditValue,
    setIsEditValue: setIsEditValue,
    pageNumber: pageData.pageNumber,
    metaData,
  }

  return (
    <WidgetLayout
      asideDate={date}
      asideTitle={pageData.title}
      pageNumber={pageData.pageNumber}
      onChange={onChangePageData}
      editMode={editMode}
      flagShortCode={metaData?.flagShortCode}
    >
      <Styled.BlueskyAnalysisWrapper>
        <UpdateButton
          {...editProps}
          contentData={{
            Post: postDatas,
          }}
          title={pageData.title}
          editMode={editMode}
          setEditMode={setEditMode}
        />
        <Styled.BlueskyAnalysisContainer>
          <Row xs={{ justify: 'center' }}>
            {postDatas ? (
              <Column xs={{ size: postDatas?.Analysis ? 7 : 8 }}>
                <div className="post">
                  <BlueSkyCard
                    data={data}
                    editmode={editMode}
                    onChange={onChange}
                  />
                  {editMode && (
                    <button
                      className="delete-post"
                      onClick={() => handleDeletePost()}
                    >
                      X
                    </button>
                  )}
                </div>
              </Column>
            ) : (
              <Column xs={{ size: 8 }}>
                <div className="add-post">
                  <input
                    type="text"
                    placeholder="Enter Post ID"
                    value={postId}
                    onChange={(e) => setPostId(e.target.value)}
                  />
                  <button onClick={addPost}>Add Post</button>
                </div>
              </Column>
            )}

            {postDatas?.Analysis && (
              <Column xs={{ size: 5 }}>
                <Analysis
                  editMode={editMode}
                  onChange={onChange}
                  data={postDatas && (postDatas as AnalysisData)}
                />
              </Column>
            )}
          </Row>
        </Styled.BlueskyAnalysisContainer>
      </Styled.BlueskyAnalysisWrapper>
    </WidgetLayout>
  )
}

export default BlueskyPosts
